import React, { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import { Player } from "../interfaces/Player.Interface";
import image from "../img/player_default.png";
import "./Teams.Styles.scss";
import CountUp from "react-countup";
import TeamSheetComponent from "../components/elements/TeamSheet.Component";
import LoadingElement from "../components/elements/Loading.Element";
import { firebaseContext } from "../contexts/FirebaseContext";
import { DB_REF } from "../constants/DB";
import { Formation } from "../interfaces/Formation.Interface";

export default function TeamsScreen() {
  const firebase = useContext(firebaseContext);
  const [loading, setLoading] = useState(true);
  const [players, setPlayers] = useState<Player[]>([]);
  const [formationPlayers, setFormationPlayers] = useState<(Player | null)[]>(
    []
  );
  const [formation, setFormation] = useState<{
    players: string[];
    formation: Formation;
  }>({ players: [], formation: { defend: 0, foward: 0, midfield: 0 } });
  const [index, setIndex] = useState(0);
  const [transition, setTransition] = useState(false);

  const beforeChange = () => {
    setTransition(true);
  };

  const afterChange = (index: number) => {
    setTransition(false);
    setIndex(index);
  };

  const settings = {
    pauseOnHover: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    beforeChange,
    afterChange,
  };

  const renderPlayer = () => {
    return players.map((ele, index) => {
      return (
        <div key={index} className="player-ele">
          <div className="jersey-number">{ele.jerseyNumber}</div>
          <img src={ele.imageUrl ? ele.imageUrl : image} alt="" />
        </div>
      );
    });
  };

  const renderTeamStripe = () => {
    const currentPlayer = players[index];
    if (currentPlayer) {
      return (
        <div className="team-stripe">
          <Slider {...settings}>{renderPlayer()}</Slider>
          <div
            className={`data ${transition ? "transition" : "no-transition"}`}
          >
            <div className="first-name">
              {currentPlayer.firstName.toUpperCase()}
            </div>
            <div className="last-name">
              {currentPlayer.lastName.toUpperCase()}
            </div>
            <div className="position">
              <div className="label">Position</div>
              <div className="position-text">
                {currentPlayer.position.toUpperCase()}
              </div>
            </div>
            <div>
              <div className="stat-container">
                <div className="stat">
                  <div className="label">Matches</div>
                  <CountUp
                    duration={1}
                    className="stat-info matches"
                    start={0}
                    end={currentPlayer.stats ? currentPlayer.stats.matches : 0}
                  />
                </div>
                <div className="stat">
                  <div className="label">Minutes Played</div>
                  <CountUp
                    duration={1}
                    className="stat-info matches"
                    start={0}
                    end={
                      currentPlayer.stats
                        ? currentPlayer.stats.minutesPlayed
                        : 0
                    }
                  />
                </div>
                <div className="stat">
                  <div className="label">
                    {currentPlayer.position !== "goalkeeping"
                      ? "Goals"
                      : "Saves"}
                  </div>
                  <CountUp
                    duration={1}
                    className="stat-info matches"
                    start={0}
                    end={
                      currentPlayer.stats
                        ? currentPlayer.position === "goalkeeping"
                          ? currentPlayer.stats.saves
                          : currentPlayer.stats.goals
                        : 0
                    }
                  />
                </div>
                <div className="stat">
                  <div className="label">Assists</div>
                  <CountUp
                    duration={1}
                    className="stat-info matches"
                    start={0}
                    end={currentPlayer.stats ? currentPlayer.stats.assists : 0}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  const getFormation = async () => {
    const docs = await firebase
      .firestore()
      .collection(DB_REF.teamCards)
      .orderBy("date")
      .limitToLast(1)
      .get();

    const playerData = await firebase
      .firestore()
      .collection(DB_REF.players)
      .where("active", "==", true)
      .get();
    let players: any[] = [];

    playerData.forEach((ele) => {
      players.push(ele.data());
    });

    if (!docs.empty) {
      const formationData = docs.docs[0].data();
      setFormation(formationData as any);
      let playerData: (Player | null)[] = [];
      for (let i = 0; i < formationData.players.length; i++) {
        const playerId = formationData.players[i];

        if (playerId) {
          let found = false;
          for (const i of players) {
            if (playerId === i.playerId) {
              found = true;
              playerData.push(i);
            }
          }
          if (!found) {
            playerData.push(null);
          }
        } else {
          playerData.push(null);
        }
      }

      setFormationPlayers(playerData);
    } else {
      console.log("Empty");
    }

    setLoading(false);
  };

  const renderTeamSheet = () => {
    return (
      <div className="team-card">
        <h1>Team Sheet - This weeks team A</h1>
        <div style={{ justifyContent: "center", display: "flex" }}>
          <TeamSheetComponent
            start={1}
            formation={formation.formation}
            players={formationPlayers}
          />
        </div>
      </div>
    );
  };

  const renderTeamSheet2 = () => {
    return (
      <div className="team-card">
        <h1>Team Sheet - This weeks team B</h1>
        <div style={{ justifyContent: "center", display: "flex" }}>
          <TeamSheetComponent
            start={11}
            formation={formation.formation}
            players={formationPlayers}
          />
        </div>
      </div>
    );
  };

  useEffect(() => {
    const getAllPlayers = async () => {
      const docs = await firebase
        .firestore()
        .collection(DB_REF.players)
        .where("active", "==", true)
        .get();
      setPlayers([]);
      const season =
        (
          await firebase
            .firestore()
            .collection(DB_REF.currentSeason)
            .doc("season")
            .get()
        ).data()!.no || 0;
      docs.forEach((ele) => {
        const playerId = ele.data().playerId;
        firebase
          .firestore()
          .collection(DB_REF.seasonStats)
          .where("season", "==", season)
          .where("playerId", "==", playerId)
          .get()
          .then((statDoc) => {
            let stats: any = {
              goals: 0,
              assists: 0,
              matches: 0,
              saves: 0,
              minutesPlayed: 0,
              season: 0,
            };

            if (!statDoc.empty) {
              stats = { ...statDoc.docs[0].data() };
            }

            let player: any = {
              ...ele.data(),
              stats: {
                ...stats,
              },
            };

            setPlayers((old) => [...old, player]);
          });
      });
      getFormation();
    };

    setLoading(true);

    getAllPlayers();
  }, []);

  if (loading) {
    return <LoadingElement />;
  }
  return (
    <div className="teams-container">
      <div>{renderTeamStripe()}</div>
      <div>{renderTeamSheet()}</div>
      <div>{renderTeamSheet2()}</div>
    </div>
  );
}
